export const USEFUL_WEBSITES = [
  { image: "/webImg/su-inter.png", path: "https://scriptureunion.global/" },
  { image: "/webImg/TBS.png", path: "https://thai.bible/" },
  { image: "/webImg/IBS.png", path: "https://www.biblica.com/" },
  { image: "/webImg/upperroom.png", path: "https://www.upperroom.org/" },
];
